import { isLeafNode } from '../../../../functions/client-model/client-node/is-leaf-node';
import { Dict } from '../../../../model/dict';
import { DashboardNodeV4 } from '../../../../public/dashboard/shared/model/dashboard-node-v4/dashboard-node-v4';

export interface TransitionTree {
  id: string;
  children: string[];
  groups: Dict<TransitionGroup>;
}
export interface TransitionGroup {
  id: string;
  title: string;
  children: string[];
  transitionIds?: string[];
}
//This is a first basic implementation, this will be reworked when we separate the dashboard model from the editor model. /Emanuel 2025-02-11
export function createTransitionTree(
  rootId: string,
  topLevelNodeIds: string[],
  nodes: Dict<DashboardNodeV4>
): TransitionTree {
  const sectorIds = topLevelNodeIds;
  const subsectorIds = sectorIds.reduce((all: string[], nodeId: string) => {
    const node = nodes[nodeId];
    return all.concat(node ? node.childNodes : []);
  }, []);
  const allIds = sectorIds.concat(subsectorIds);
  const groups: Dict<TransitionGroup> = allIds.reduce((acc: Dict<TransitionGroup>, nodeId) => {
    const node = nodes[nodeId];
    const transitionsForNode = getTransitionIds(node, nodes);
    const shouldHaveTransitions = !sectorIds.includes(nodeId) || containsOnlyLeaves(node, nodes);
    if (node) {
      acc[node.id] = {
        id: node.id,
        title: node.title,
        children: node.childNodes,
        transitionIds: shouldHaveTransitions ? transitionsForNode : undefined,
      };
    }
    return acc;
  }, {});
  return {
    id: rootId,
    children: topLevelNodeIds,
    groups,
  };
}
// If we have one leaf we can expect all nodes to be leaves, but we'll check them all anyway.
function containsOnlyLeaves(node: DashboardNodeV4, nodes: Dict<DashboardNodeV4>): boolean {
  return node.childNodes.reduce((all: boolean, nodeId: string) => {
    const child = nodes[nodeId];
    return all && isLeafNode(child);
  }, true);
}

function getTransitionIds(node: DashboardNodeV4, nodes: Dict<DashboardNodeV4>): string[] {
  if (isLeafNode(node)) {
    return [node.id];
  }
  return node.childNodes.reduce((all: string[], nodeId: string) => {
    const node = nodes[nodeId];
    return all.concat(node ? getTransitionIds(node, nodes) : []);
  }, []);
}
